import * as React from 'react';
import { Data, ManageableQuickscanData, State } from "../types";

export const getEmptyQuickscanState = (): State.Quickscan => {
    return {
        quickscan: getEmptyQuickscan(),
        currentStep: 0,
        finished: false,
        error: false,
        visited: [
            false,
            false,
            false,
            false
        ],
        validation: {
            fields : {
                organisation: true,
                address: true,
                zipcode: true,
                city: true,
                firstName: true,
                lastName: true,
                position: true,
                otherInfo: true,
                phoneNumber: true,
                fte: true,
                previousRevenue: true,
                currentRevenue: true,
                activities: true,
                innovation: true,
                ip: true,
                amount: true,
                equipment: true,
                alternativeFunding: true,
                otherFinancing: true,
                privacy: true,
            },
            steps: [
                true,
                true,
                true,
                true
            ]
        },
    };
}

export const getEmptyQuickscan = (): Data.Quickscan => {
    return {
        type: '',
        organisation: '',
        address: '',
        zipcode: '',
        city: '',
        firstName: '',
        lastName: '',
        position: '',
        otherInfo: '',
        phoneNumber: '',
        foundingDate: new Date(),
        fte: 0,
        previousRevenue: 0,
        currentRevenue: 0,
        category:'Agro/Food',
        activities:'',
        innovation:'',
        ip:'',
        amount:0,
        period:'',
        equipment: '',
        alternativeFunding: '',
        otherFinancing: '',
        nda: false,
        privacy: false,
        questions: '',
    };
}

export const QuickscanDataContext: React.Context<ManageableQuickscanData> = React.createContext<ManageableQuickscanData>([
    getEmptyQuickscanState(),
    () => {
    }
]);
